import { useMemo } from 'react';
import { toString } from 'lodash';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';

export const useOrganizationLevels = () => {
  const {
    observingOrganization: {
      id: observingOrganizationId, type, path, name,
    },
  } = useCurrentOrganization();
  const id = toString(observingOrganizationId);

  const isSystemLevel = useMemo(() => type === OrganizationTypes.system, [type]);
  const isPartnerLevel = useMemo(() => type === OrganizationTypes.partner, [type]);
  const isDistributorLevel = useMemo(() => type === OrganizationTypes.distributor, [type]);
  const isCompanyLevel = useMemo(() => type === OrganizationTypes.company, [type]);

  const currentOrgLevels = useMemo(() => {
    if (isSystemLevel) return [OrganizationTypes.partner, OrganizationTypes.distributor, OrganizationTypes.company, OrganizationTypes.subsidiary];
    if (isPartnerLevel) return [OrganizationTypes.partner, OrganizationTypes.distributor, OrganizationTypes.company, OrganizationTypes.subsidiary];
    if (isDistributorLevel) return [OrganizationTypes.distributor, OrganizationTypes.company, OrganizationTypes.subsidiary];
    if (isCompanyLevel) return [OrganizationTypes.company, OrganizationTypes.subsidiary];
    return [];
  }, [isSystemLevel, isPartnerLevel, isDistributorLevel, isCompanyLevel]);

  const [systemId] = useMemo(() => {
    if (isSystemLevel) {
      return [id];
    }
    return (path || '').split('\\').slice(1, 5);
  }, [path, isSystemLevel, id]);

  return {
    id,
    type,
    name,
    isSystemLevel,
    isPartnerLevel,
    isDistributorLevel,
    isCompanyLevel,
    currentOrgLevels,
    systemId,
  };
};

export default useOrganizationLevels;
